import { FORM_LIBRARY } from "../../constants/action-types";

const initialState = {
  designBreadcrumbs: [],
  formLibraryContent: [],
  folder_info: [],
  form_library_archive: [],
  form_library_folderRenamed: [],
  getAllFoldersTreeview: [],
  moveEditorFolder_info: [],
  dragItem: [],
  specialLinks: [],
  formTemplates: [],
};

const FormLibrary = (state = initialState, action) => {
  switch (action.type) {
    case FORM_LIBRARY.DESIGN_BREADCRUMBS_ADD: {
      return {
        ...state,
        designBreadcrumbs: state.designBreadcrumbs.concat(action.payload),
      };
    }
    case FORM_LIBRARY.DESIGN_BREADCRUMBS_REMOVE: {
      if (action.payload) {
        return {
          ...state,
          designBreadcrumbs: state.designBreadcrumbs.filter(
            (x) => x.Id <= action.payload
          ),
        };
      } else {
        return {
          ...state,
          designBreadcrumbs: [],
        };
      }
    }
    case FORM_LIBRARY.DRAG_EVENT: {
      return {
        ...state,
        dragItem: action.payload,
      };
    }
    case FORM_LIBRARY.GET_ALL_CONTENT: {
      return Object.assign({}, state, {
        formLibraryContent: action.payload,
      });
    }
    case FORM_LIBRARY.ADD_FOLDER: {
      return Object.assign({}, state, {
        folder_info: action.payload,
      });
    }
    case FORM_LIBRARY.ARCHIVE: {
      return Object.assign({}, state, {
        form_library_archive: action.payload,
      });
    }
    case FORM_LIBRARY.SPECIAL_LINK: {
      return Object.assign({}, state, {
        specialLinks: action.payload,
      });
    }
    case FORM_LIBRARY.RENAME: {
      return Object.assign({}, state, {
        form_library_folderRenamed: action.payload,
      });
    }
    case FORM_LIBRARY.GET_ALL_FOLDERS_TREEVIEW: {
      return Object.assign({}, state, {
        getAllFoldersTreeview: action.payload,
      });
    }
    case FORM_LIBRARY.MOVE: {
      return Object.assign({}, state, {
        moveEditorFolder_info: action.payload,
      });
    }
    case FORM_LIBRARY.GET_FORM_TEMPLATES_WITH_DETAILS: {
      return Object.assign({}, state, {
        formTemplates: action.payload,
      });
    }
    default:
      return state;
  }
};

export default FormLibrary;
